<template>
  <div id="app">
    <index-header ref="appIndexHeader" :headColor="headColor"></index-header>
    <div class="appData container">
      <transition appear>
        <router-view
          v-if="isRouterAlive"
          @onLoading="loadingShow = true"
          @offLoading="loadingShow = false">
        </router-view>
      </transition>
    </div>
    <transition name="toast">
      <toast :err="msg" v-if="toastShow">
      </toast>
    </transition>
    <index-foot v-show="showIndexFoot"></index-foot>
    <div class="loading" v-if="loadingShow">
      <div><img src="./assets/image/Icon_loading.png" class="rotate"></div>
    </div>
  </div>
</template>

<script>
import indexHeader from './components/common/indexHeader.vue'
import indexFoot from './components/common/indexFoot.vue'
import toast from './components/common/toast.vue'
export default {
  components: {
    indexHeader,
    indexFoot,
    toast
  },
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      countNum: '',
      headColor: '',
      showIndexFoot: true,
      transitionName: 'slide-left',
      toastShow: false,
      loadingShow: false,
      msg: '',
      // 新加入
      isRouterAlive: true,
      PageHistory: ['']
    }
  },
  mounted: function () {
    this.headColor = this.$route.name
    if (this.$route.meta.notFoot) {
      this.showIndexFoot = false
    } else {
      this.showIndexFoot = true
    }
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    alertMsg: function (msg) {
      this.msg = msg
      this.toastShow = true
      setTimeout(() => {
        this.toastShow = false
        this.$store.commit('setToastMsg', '')
      }, 2000)
    }
  },
  computed: {
    // 映射根组件实例的data
    mapState: function () {
      return this.$store.getters.showMsg
    }
  },
  watch: {
    '$route': function (to, from) {
      if (this.PageHistory.length <= 0) {
        return
      }
      if (to.name === this.PageHistory[this.PageHistory.length - 1]) {
        this.transitionName = 'slide-right'
        this.PageHistory.pop()
      } else {
        this.transitionName = 'slide-left'
        this.PageHistory.push(from.name)
        window.scrollTo(0, 0)
      }
      if (to.meta.notFoot) {
        this.showIndexFoot = false
      } else {
        this.showIndexFoot = true
      }
      if (to.name === 'productDetail') {
        window.location.reload()
        // this.$route.go(0)
      }
      console.log(to.name)
      this.headColor = to.name
      this.countNum = to.name
      this.$refs.appIndexHeader.init()
    },
    // 监测根组件实例的data
    'mapState': function (newMsg) {
      if (newMsg) {
        this.alertMsg(newMsg)
      }
    }
  }
}
</script>

<style>
@import "./assets/css/style.css";
@import "./assets/css/color.css";
@import "./assets/css/iconfont.css";
.appData {
  min-height: 680px;
}
#app {
  text-align: center;
  color: #2c3e50;
  background-color: #FFFFFF;
  min-height: 680px;
  font-size: 1em;
  min-width: 1200px;
}
@font-face {
  font-family: "FZYH_508R";
  src: url('/static/fonts/FZYH_508R.eot');
  src: url('/static/fonts/FZYH_508R.eot') format("embedded-opentype"),
  url('/static/fonts/FZYH_508R.woff2') format("woff2"),
  url('/static/fonts/FZYH_508R.woff') format("woff"),
  url('/static/fonts/FZYH_508R.ttf') format("truetype"),
  url('/static/fonts/FZYH_508R.svg') format("svg");
  font-style: normal;
  font-weight: 200
}

@font-face {
  font-family: "FZYH_510M";
  src: url('/static/fonts/FZYH_510M.eot');
  src: url('/static/fonts/FZYH_510M.eot') format("embedded-opentype"),
  url('/static/fonts/FZYH_510M.woff2') format("woff2"),
  url('/static/fonts/FZYH_510M.woff') format("woff"),
  url('/static/fonts/FZYH_510M.ttf') format("truetype"),
  url('/static/fonts/FZYH_510M.svg') format("svg");
  font-style: normal;
  font-weight: 200
}
*{
  font-family: 'Microsoft YaHei', Helvetica, Arial, sans-serif;
}
.slide-left-enter-active,
.slide-right-leave-active,
.slide-right-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all .3s;
  height: 100%;
  width: 100%;
  top: 0;
  position: absolute;
  backface-visibility: hidden;
  perspective: 1000;
}
.slide-right-enter {
  top: 0;
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}

.slide-right-leave-active {
  top: 0;
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}

.slide-left-enter {
  top: 0;
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}

.slide-left-leave-active {
  top: 0;
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
#app{
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.auto-item{
  font-size: 0.26rem;
  margin-bottom: 0.2rem;
}
.auto-item span{
  font-size: 0.22rem;
}
.toast{
  position: fixed;
  bottom: 50%;
  text-align: center;
  width: 100%;
  z-index: 10000;
  opacity: 1;
}
#toast>span{
  display: inline-block;
  padding: 10px 20px;
  background-color: rgba(0,0,0,0.6);
  color: #fff;
  border-radius: 6px;
  font-size: 16px;
}
.toast-enter-active{
  animation:up-in .5s;
}
.toast-leave-active{
  animation:down-out .5s;
}
.swiper-pagination-bullet {
  width: 15px !important;
  height: 15px !important;
  background: rgba(256,256,256,0) !important;
}
.swiper-pagination-bullet svg circle {
  fill: #FFF;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: 37 37;
  stroke-dashoffset: 37;
  -webkit-transition: stroke-dashoffset 4.5s linear;
  transition: stroke-dashoffset 4.5s linear;
}
.swiper-pagination-bullet-active svg circle {
  fill: rgba(256,256,256,0);
  stroke: #fff;
  stroke-dashoffset: 0;
  -webkit-transition: stroke-dashoffset 4.5s linear;
  transition: stroke-dashoffset 4.5s linear;
}
</style>



// WEBPACK FOOTER //
// src/App.vue